import * as React from 'react';
import { CTA } from '../../../components/CTA';
import { LoadingIndicatorControlled } from '../../../components/LoadingIndicator/LoadingIndicator';
import { WelcomePageDropdown } from '../../../components/Newsletter/WelcomePageDropdown';
import * as Colors from '../../../consts/variables';
import { defaultCountries, defaultHarbours, defaultPromoters } from '../../../consts/welcomePage';
import { eventTracker } from '../../../helpers/EventTracker/EventTracker';
import { getPrivacyLink } from '../../../helpers/privacyLinkHelper';
import { TestSelector } from '../../../helpers/TestSelector';
import { __ } from '../../../helpers/TranslationService';

export function LoadingIndicatorInline() {
    return (
        <span>
            <LoadingIndicatorControlled isLoading style={styles.loadingIndicatorWrapper} />
        </span>
    );
}

export function SuccessMessage(props) {
    let subText =
        'you are just one step away from getting all top offers: Please go to your E-Mail provider and verify your E-Mail address.';
    let welcomePageCTA;
    if (props.isWelcomePage) {
        subText = 'You will receive the 200€ cashback code in your next mail from us';
        const onClick = () => {
            eventTracker.track({
                category: 'Port Sign Up',
                action: 'thank you page',
                label: props.portal,
            });
            window.location.href = props.portal;
        };
        welcomePageCTA = (
            <CTA onClick={onClick} wrapperStyle={styles.thankyouButton}>
                <span>{__('Search for cruise offers now', 'dreamlines')}</span>
            </CTA>
        );
    }
    return (
        <div
            className="newsletterForm"
            {...TestSelector.getSelector('newsletterJoinUs-thankYouMsg')}
        >
            <h4 style={styles.thankYouMsg}>
                {__('Thank you! Your registration was successful!', 'dreamlines')}
            </h4>
            <div style={styles.thankYouSubText}>{__(subText, 'dreamlines')}</div>
            {welcomePageCTA}
        </div>
    );
}

export function ErrorMessage(props) {
    return (
        <div className="newsletterForm">
            <h4 style={styles.submitErr}>{__('newsletter submit error msg', 'dreamlines')}</h4>
            <div style={styles.retryBtnWrapper}>
                <CTA onClick={props.formSubmitHandler} wrapperStyle={styles.retryBtn}>
                    <span>{__('Try Again', 'dreamlines')}</span>
                </CTA>
            </div>
        </div>
    );
}

export function FormContainer(props) {
    const heading = props.isWelcomePage ? { ...styles.heading, margin: 'auto' } : styles.heading;
    const privacyLinkText = props.isWelcomePage
        ? 'welcome privacy link text'
        : 'newsletter privacy link text';
    const privacyLink = getPrivacyLink(
        __(privacyLinkText, 'dreamlines'),
        __('newsletter.link', 'dreamlines'),
    );
    return (
        <div className="newsletterForm">
            <h3 style={heading}>{props.newsletterHeadline}</h3>
            <form onSubmit={props.formSubmitHandler} style={styles.formContainer}>
                <div style={styles.formElement}>
                    <input
                        style={styles.formInput}
                        placeholder={__('your mail address', 'dreamlines')}
                        value={props.input}
                        onChange={props.handleChange('email')}
                        {...TestSelector.getSelector('newsletterJoinUs-email')}
                    />
                    {!props.isValid && (
                        <div style={styles.errMsg}>{__('incorrect email', 'dreamlines')}</div>
                    )}
                    {props.isLoading && (
                        <div style={styles.loadingIndicator}>
                            <LoadingIndicatorInline />
                        </div>
                    )}
                </div>
                {props.isWelcomePage && (
                    <>
                        <WelcomePageDropdown
                            value={props.countryIndex}
                            instanceId="country"
                            onChange={props.handleChange('country')}
                            isValid={props.isCountryValid}
                            options={defaultCountries}
                        />
                        <WelcomePageDropdown
                            value={props.harbourIndex}
                            instanceId="harbour"
                            onChange={props.handleChange('harbour')}
                            isValid={props.isHarbourValid}
                            options={defaultHarbours}
                        />
                        <WelcomePageDropdown
                            value={props.promoterIndex}
                            instanceId="promoter"
                            onChange={props.handleChange('promoter')}
                            isValid={props.isPromoterValid}
                            options={defaultPromoters}
                        />
                    </>
                )}
                <div style={styles.formElement}>
                    <CTA
                        onClick={props.formSubmitHandler}
                        testSelectorName={'newsletterJoinUs-submitRequest'}
                    >
                        <span>{__('Join', 'dreamlines')}</span>
                    </CTA>
                </div>
                <div
                    style={styles.formSubText}
                    className="html-with-links"
                    dangerouslySetInnerHTML={{ __html: privacyLink }}
                />
            </form>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    loadingIndicator: {
        position: 'absolute',
        right: 15,
        top: 9,
    },
    loadingIndicatorWrapper: {
        width: 4,
        height: 4,
        fontSize: 4,
        margin: '10px auto',
    },

    heading: {
        margin: '0px 0px 40px 0px',
        fontWeight: 'bold',
        lineHeight: '1.2em',
        fontSize: 22,
        color: Colors.darkBlack,
    },
    formContainer: {
        margin: '0px 15px 0px',
    },
    formElement: {
        margin: '20px 0px 0px',
        position: 'relative',
    },
    formInput: {
        borderColor: Colors.darkGray,
        textAlign: 'center',
        width: '100%',
        padding: '10px 20px',
        fontSize: 15,
        border: `1px solid ${Colors.darkGray}`,
    },
    errMsg: {
        color: Colors.pink,
        fontSize: 12,
        margin: '5px 0',
        textAlign: 'left',
    },
    formSubText: {
        margin: '20px 0 0',
        fontSize: 13,
        lineHeight: 1.3,
        textAlign: 'center',
    },
    submitErr: {
        fontSize: 16,
        margin: '10px 0px',
    },
    retryBtnWrapper: {
        margin: '25px auto',
    },
    retryBtn: {
        display: 'inline-block',
        padding: '15px 35px',
    },
    thankYouMsg: {
        fontSize: 20,
        fontWeight: 'bold',
        margin: '10px 0px',
        color: Colors.darkBlack,
    },
    thankYouSubText: {
        fontSize: 14,
        marginTop: 20,
    },
    thankyouButton: {
        display: 'inline-block',
        padding: '15px 34px',
        marginTop: 20,
        fontSize: 16,
    },
};
